const IframeTest = ({url}: {url: string}) => {

    return (
        <iframe
            style={{borderRadius: '6px'}}
            id="mainIframe"
            src={url}
            width="700"
            height="560"
        />
    );
};

export default IframeTest;
